import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { baseURLProd } from '../../api';

const MaterialHook = () => {
    const [marksData,setMarksData] =useState(false)
    const [showModal, setShowModal] = useState(false);
    const [data, setData] = useState([]);
    const toggleModal = () => setShowModal(!showModal);
  
    const navigate = useNavigate();

    const userId =localStorage.getItem('userId')
    useEffect(() => {
        const formData = new FormData();
        formData.append("user_id", userId);

        fetch(`${baseURLProd}martial-section-name`, {
            method: "POST",
            body: formData,
        })
        .then((response) => response.json())
        .then((result) => {
          if (result.status) {
            setData(result.data);
          }
        })
        .catch((error) => console.error("Error fetching data:", error));
    }, []);
  
    const handleMaterial = () => {
        navigate('/material')
    }
    const handleInnerPage=(topic_id)=>{
        const formData = new FormData();
        formData.append("user_id", userId);
        formData.append("topic_id", topic_id);

        fetch(`${baseURLProd}get-all-pdf`, {
            method: "POST",
            body: formData,
        })
        .then((response) => response.json())
        .then((result) => {
          if (result.status) {
            navigate(`/materialDetail`, { state: { materialdetail: result.data } });
          }
        })
        .catch((error) => console.error("Error fetching data:", error));
    }
    const handleSave =()=>{
        setMarksData(true)
    }
    return {
        handleMaterial,handleSave,marksData,toggleModal,showModal,data,handleInnerPage
    }
}

export default MaterialHook
